import ApolloClient from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { createLink } from './link';
import createDataIdFromObject from './createDataIdFromObject';
import { IS_SERVER } from '../../../../config/environment';

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
        __schema: {
            types: []
        }
    }
});

const createClient = ({
    ssrMode = IS_SERVER,
    link,
    dataIdFromObject = createDataIdFromObject(),
    initialState = {},
    cookies = {}
} = {}) => {
    return new ApolloClient({
        ssrMode,
        link: link ? link : createLink(IS_SERVER, cookies),
        defaultOptions: {
            query: {
                errorPolicy: 'all'
            }
        },
        cache: new InMemoryCache({
            fragmentMatcher,
            dataIdFromObject,
            addTypename: true
        }).restore(initialState)
    });
};

export default createClient;
